import { render } from "./WalletDashboard.vue?vue&type=template&id=afbb6016&scoped=true&ts=true"
import script from "./WalletDashboard.vue?vue&type=script&lang=ts"
export * from "./WalletDashboard.vue?vue&type=script&lang=ts"

import "./WalletDashboard.vue?vue&type=style&index=0&id=afbb6016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbb6016"]])

export default __exports__